<div class="city-page-container" *ngIf="!loading">
    <app-section [style]="tab ? 'position: sticky; top: 0' : ''">
        <app-title-background
            [locationDto]="getCorrectLocation()"
            [hotelSection]="true"
        />
    </app-section>
  <app-section *ngIf="!tab">
    <app-running-line
      [otherText]="true"
      [text]="[{text: [this.cityDto.country?.continent?.runningLineRu ?? 'bla-bla-bla', this.cityDto.country?.continent?.runningLine ?? 'bla-bla-bla']}]"
    />
    <app-looped-slider [cards]="sliderCards" [grid]="grid"/>
  </app-section>
    <app-section>
        <app-main-busy-bee
            [cards]="cityCards"
            [texts]="getCorrectTexts('first')"
        />
    </app-section>
    <app-section *ngIf="hotelCards.length > 0" >
        <app-main-best-hotels
                [texts]="getCorrectTexts('hotel')"
                [search]="true"
                [subtitle]="true"
                [cards]="hotelCards"
                [main]="false"
                [type]="'city'"
                [typeContent]="typeContent"
        />
    </app-section>
  <div class="sticky-section-wrapper" style="background: var(--background-color)">
    <app-section class="sticky-section">
      <app-main-busy-bee
        [cards]="cityAdditionalCards"
        [texts]="getCorrectTexts('second')"
      />
    </app-section>
  </div>
  <app-section-scroller class="overlapping-content">
    <app-main-destinations (ClickOnActive)="goToDestination($event)" (loadingEmit)="loadCircle($event)"/>
  </app-section-scroller>
</div>
<app-admin-preview [adminDisplay]="adminDisplay" [uncorrectedUrl]="uncorrectedUrl" [displayPageFalse]="displayPageFalse"/>
